import { Cloudinary } from '@cloudinary/url-gen';
import { dpr, format, quality } from '@cloudinary/url-gen/actions/delivery';
import { crop, fill, limitFill } from '@cloudinary/url-gen/actions/resize';
import { face } from '@cloudinary/url-gen/qualifiers/focusOn';
import { auto as autoFormat } from '@cloudinary/url-gen/qualifiers/format';
import { autoGravity, focusOn } from '@cloudinary/url-gen/qualifiers/gravity';
import { auto as autoQuality } from '@cloudinary/url-gen/qualifiers/quality';
const cl = new Cloudinary({
    cloud: {
        cloudName: 'dgj1zw4nt',
    },
    url: {
        secure: true,
    },
});
/**
 * Create an image URL for ImageProcessor
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function imageUrl(image, imageParams) {
    if (!image?.src) {
        return '';
    }
    let clImage = cl.image(image.src);
    const resizeAction = getResizeAction(image, imageParams);
    if (resizeAction) {
        clImage = clImage.resize(resizeAction);
    }
    clImage = clImage.delivery(getFormatAction(imageParams)).delivery(quality(autoQuality()));
    if (imageParams.dpr) {
        clImage = clImage.delivery(dpr(imageParams.dpr));
    }
    return clImage.toURL();
}
function getResizeAction(image, imageParams) {
    if (!imageParams.width && !imageParams.height) {
        console.warn(`Image Not Resized: "${image.src}"`, image, imageParams);
        return undefined;
    }
    let resizeAction;
    switch (imageParams.crop) {
        case 'crop':
            resizeAction = crop();
            break;
        case 'fill':
            resizeAction = fill();
            break;
        case 'lfill':
            resizeAction = limitFill();
            break;
        default:
            resizeAction = fill();
            break;
    }
    if (imageParams.width) {
        resizeAction = resizeAction.width(imageParams.width);
    }
    else if (imageParams.widthratio) {
        resizeAction = resizeAction.aspectRatio(imageParams.widthratio);
    }
    if (imageParams.height) {
        resizeAction = resizeAction.height(imageParams.height);
    }
    else if (imageParams.heightratio) {
        resizeAction = resizeAction.aspectRatio(imageParams.heightratio);
    }
    if (imageParams.gravity === 'face') {
        resizeAction = resizeAction.gravity(focusOn(face()));
    }
    else {
        resizeAction = resizeAction.gravity(autoGravity());
    }
    return resizeAction;
}
function getFormatAction(imageParams) {
    let formatAction;
    if (imageParams.format) {
        formatAction = format(imageParams.format);
    }
    else {
        formatAction = format(autoFormat());
    }
    return formatAction;
}
export function getSrcs(image, upper, lower, steps, ratio) {
    const sizes = getRange(upper, lower, steps);
    return sizes.map((size) => `${imageUrl(image, { width: size, heightratio: ratio })} ${size}w`);
}
function getRange(upper, lower, steps) {
    const difference = upper - lower;
    const increment = difference / (steps - 1);
    return [
        lower,
        ...Array(steps - 2)
            .fill('')
            .map((_, index) => lower + increment * (index + 1)),
        upper,
    ];
}
